import { render, staticRenderFns } from "./CCCappingByClientPreValidation.vue?vue&type=template&id=ddc3e3bc"
import script from "./CCCappingByClientPreValidation.vue?vue&type=script&lang=js"
export * from "./CCCappingByClientPreValidation.vue?vue&type=script&lang=js"
import style0 from "./CCCappingByClientPreValidation.vue?vue&type=style&index=0&id=ddc3e3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports